module.exports = __webpack_public_path__ + "img/finance.878028f7.png";